// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

// import React from 'react';
// import ReactDOM from 'react-dom';
// import {StoreContext} from './Store';
// import { Provider, useSelector, useActions } from "react-redux";

// import {makeStore} from './Store';

// const store = makeStore();

// ReactDOM.render(
//   <Provider value={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root'),
// );


import React from 'react';
import { render } from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './reducers/index';
import App from './App';
import "./theme/globalStyle.css";

const store = createStore(rootReducer)

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
